import {createEntityAdapter, Dictionary, EntityAdapter, EntityState} from '@ngrx/entity';
import {ActionReducer, createReducer, on} from '@ngrx/store';
import {createFeature, createSelector} from '@ngrx/store';
import {VisitScheduleModel} from "../../../models/visit-schedule.model";
import {
  VisitScheduleActions,
  VisitScheduleAPiActions,
  VisitScheduleChannelActions
} from "./visit-plan-schedule.actions";
import {VisitPlanActions} from "../visit-plan-state/visit-plan.actions";

export interface VisitScheduleState extends EntityState<VisitScheduleModel> {
  isLoading: boolean;
}

const adapter: EntityAdapter<VisitScheduleModel> = createEntityAdapter<VisitScheduleModel>();

const initialState: VisitScheduleState = adapter.getInitialState({
  isLoading: false
});


const reducer: ActionReducer<VisitScheduleState> = createReducer(
  initialState,

  on(VisitScheduleChannelActions.notificationReceived, (state, {notification}) => {
    if (state.entities[notification.id]?.updatedAt < notification.updatedAt) {
      return adapter.setOne(notification, state);
    } else {
      return state;
    }
  }),

  on(VisitScheduleAPiActions.initVisitScheduleSuccess, (state, {visitPlan, visitScheduleConfig}) => {
    return adapter.setOne({...state.entities[visitPlan.scheduleId], visitScheduleOptimizationSettings: visitScheduleConfig}, {...state});
  }),

  on(VisitScheduleAPiActions.getVisitSchedule, (state) => ({...state, isLoading: true})),

  on(VisitScheduleAPiActions.getVisitScheduleSuccess, (state, {visitSchedule}) => {
    return adapter.setOne(visitSchedule, {...state, isLoading: false})
  }),

  on(VisitScheduleAPiActions.getVisitScheduleFailure, (state) => ({...state, isLoading: false})),

  on(VisitScheduleActions.setOne, (state, {visitSchedule}) => {
    return adapter.setOne(visitSchedule, state)
  }),

  on(VisitScheduleActions.removeAll, (state) => adapter.removeAll(state)),

  on(VisitScheduleActions.clearStore, () => ({...initialState}))
);

export const visitScheduleFeature = createFeature({
  name: 'VisitSchedule',
  reducer,
  extraSelectors: ({
                     selectVisitScheduleState,
                     selectEntities,
                     selectIsLoading,
                   }) => ({
    ...adapter.getSelectors(selectVisitScheduleState),
    selectVisitSchedules: () => createSelector(
      selectEntities,
      (entities: Dictionary<VisitScheduleModel>) => Object.values(entities),
    ),
    selectVisitSchedulesById: (ids: string[]) => createSelector(
      selectEntities,
      (entities: Dictionary<VisitScheduleModel>) => {
        const visitSchedules = [];
        ids?.forEach(id => {
          if (!!entities[id]) {
            visitSchedules.push(entities[id]);
          }
        });
        return visitSchedules;
      },
    ),
    selectVisitSchedule: (id: string) => createSelector(
      selectEntities,
      (entities: Dictionary<VisitScheduleModel>) => {
        return entities[id]
      },
    ),
    selectIsLoading: () => createSelector(
      selectIsLoading,
      (isLoading) => isLoading
    )
  })
});

